import React from 'react';
import { ShieldCheckIcon, CheckIcon } from 'lucide-react';
import { SectionReveal } from '../SectionReveal';
const POINTS = ['Te devolvemos el 100%.', 'Sin preguntas.', 'Sin formularios.', 'Sin drama.'];
export function Guarantee() {
  return <section className="w-full bg-carbon-2" aria-labelledby="guarantee-heading" data-id="element-135">
      <SectionReveal className="mx-auto max-w-3xl px-5 py-16 sm:py-20" data-id="element-136">
        <div className="rounded-xl border-2 border-emerald bg-carbon p-8 text-center sm:p-12" data-id="element-137">
          <ShieldCheckIcon className="mx-auto h-16 w-16 text-emerald" aria-hidden="true" data-id="element-138" />
          <h2 id="guarantee-heading" className="mt-4 font-heading text-3xl font-extrabold uppercase tracking-tight text-emerald" data-id="element-139">
            Garantía 7 días
          </h2>
          <p className="mt-4 text-soft" data-id="element-140">Abrís todo. Lo revisás. Lo aplicás.</p>
          <p className="mt-2 text-muted" data-id="element-141">
            Si en 7 días no es lo que esperabas:
          </p>

          <ul className="mx-auto mt-6 flex max-w-md flex-col gap-2 text-left sm:flex-row sm:flex-wrap sm:justify-center" data-id="element-142">
            {POINTS.map(p => <li key={p} className="flex items-center gap-2 text-soft" data-id="element-143">
                <CheckIcon className="h-5 w-5 flex-none text-emerald" data-id="element-144" />
                {p}
              </li>)}
          </ul>

          <div className="mt-8" data-id="element-145">
            <span className="inline-block rounded-full bg-emerald px-5 py-2 font-heading text-sm font-bold uppercase tracking-wide text-carbon" data-id="element-146">
              Devolución completa
            </span>
          </div>

          <p className="mt-6 text-sm text-muted" data-id="element-147">
            Más de 500 deportistas ya lo tienen. Tasa de devoluciones: menor al
            1%.
          </p>
        </div>
      </SectionReveal>
    </section>;
}